// HelpBot admin modules;
import app from './app';

const Head = () => {

   return(
      <header className="ask-henry-head">
        <img alt="Logo" src={app.prefix + '/rutgers-logo-white.png'} />
        <span>{app.name} {app.who()} {app.platform}</span>
      </header>
   );

} // Class Head;

export default Head;